// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1t18Z","author":"Table_author__2SWZr","authorImage":"Table_authorImage__DAtIJ","unreadRow":"Table_unreadRow__3xK_Z"};